
import { BrowserRouter, useLocation } from 'react-router-dom'
import { AppRoutes } from './router'
import Header from './components/feature/Header'
import Footer from './components/feature/Footer'

function AppContent() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');

  return (
    <div className="min-h-screen flex flex-col">
      {!isAdmin && <Header />}
      <main className="flex-1">
        <AppRoutes />
      </main>
      {!isAdmin && <Footer />}
    </div>
  );
}

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppContent />
    </BrowserRouter>
  )
}

export default App
